export default __webpack_public_path__ + "static/media/DOC.0528476f.png";